import styled from 'styled-components';
import { IconButtonState } from '.';

interface BaseProps {
	state: IconButtonState;
	colors?: {
		disabled?: string;
		hover?: string;
		active?: string;
		selected?: string;
		border?: string;
		text?: string;
	};
	isMobile?: boolean;
}

export const Base = styled.button<BaseProps>`
	// layout
	display: flex;
	align-items: center;
	justify-content: center;
	height: 30px;
	padding: 2px 6px 0 6px;
	border: 1px solid ${({ theme, colors }) => colors?.border || theme.gray[200]};
	border-radius: 4px;
	outline: none;
	cursor: default;
	transform: ${({ isMobile }) => (isMobile ? 'scale(1.3)' : 'scale(1)')};
	transform-origin: center;
	transition: all 0.2s ease;

	// style based on state
	background-color: ${({ state, theme, colors }) => {
		if (state === IconButtonState.DISABLED) {
			return colors?.disabled || theme.gray[400];
		}
		if (state === IconButtonState.SELECTED) {
			return colors?.selected || theme.blue[500];
		}
		return 'transparent';
	}};

	&:hover {
		background-color: ${({ state, theme, colors }) => {
			if (state === IconButtonState.DISABLED) {
				return colors?.disabled || theme.gray[400];
			}
			if (state === IconButtonState.SELECTED) {
				return colors?.selected || theme.blue[500];
			}
			return colors?.hover || theme.gray[200];
		}};
		box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
	}

	&:active {
		background-color: ${({ state, theme, colors }) => {
			if (state === IconButtonState.DISABLED) {
				return colors?.disabled || theme.gray[400];
			}
			if (state === IconButtonState.SELECTED) {
				return colors?.selected || theme.blue[500];
			}
			return colors?.active || theme.gray[100];
		}};
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.6;
	}
`;

export const Icon = styled.div`
	// filter out mouse events on the icon, so that all clicks go to the base
	// otherwise Icon will block clicks on Base, and we won't detect when the user clicks the button
	pointer-events: none;
`;

export const Label = styled.div`
	font-size: 11px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	padding-left: 4px;
	padding-right: 4px;
	padding-bottom: 2px;
	pointer-events: none;
`;
